(function ($) {
    'use strict';
    $(document).ready(function () {
        $("#sylius_product_option_values input[id$='_code']").closest(".field").hide();

        $("#sylius_product_option_values").on("click", 'a[data-form-collection="add"]', function () {
            $("#sylius_product_option_values input[id$='_code']").closest(".field").hide();
        });
    });
})(jQuery);
